import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Menu, X } from 'lucide-react';
import { useLanguage } from '@/hooks/use-language';

interface MobileDetailHeaderProps {
  onBack: () => void;
  onMenuToggle: () => void;
  isMenuOpen: boolean;
  showMenu?: boolean;
}

export const MobileDetailHeader: React.FC<MobileDetailHeaderProps> = ({ 
  onBack, 
  onMenuToggle, 
  isMenuOpen,
  showMenu = true
}) => {
  const { t } = useLanguage();

  return (
    <div className="relative w-full flex items-center justify-center">
      {/* Back Arrow (Left) */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2">
        <button
          onClick={onBack}
          className="p-2 -ml-2 text-white/60 hover:text-primary transition-colors flex items-center justify-center"
          aria-label={t('common.back')}
        >
          <ArrowLeft size={24} className="text-primary" />
        </button>
      </div>
      
      {/* Logo (Center) - Matching Home page size and centering */}
      <Link to="/" className="flex items-center">
        <img 
          src="https://firebasestorage.googleapis.com/v0/b/blink-451505.firebasestorage.app/o/user-uploads%2FfrUaM52DXdWd1f2WHAbNwcoVhba2%2F08__3e9c1a05.png?alt=media&token=08603184-d1c7-42c9-b08d-947d315212e8" 
          alt="SARGO" 
          className="h-6 w-auto object-contain"
        />
      </Link>
      
      {/* Menu (Right) - Hidden on specified pages as per Header logic */}
      {showMenu && (
        <div className="absolute right-0 top-1/2 -translate-y-1/2">
          <button 
            className="text-white p-2 hover:bg-white/5 transition-colors flex items-center justify-center"
            onClick={onMenuToggle}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      )}
    </div>
  );
};
